<template>
  <v-layout row wrap id="create-api" class="d-flex justify-center align-center fill-height">
    <v-col>
      <v-flex>
        <v-card class="add-edit-wrapper ma-auto mb-10" width="722">
          <div class="close-btn">
            <i class="material-icons dark--text" @click="$router.push('/utilities')">
              clear
            </i>
          </div>
          <v-toolbar color="primary" dark class="shadow-none">
            <v-card-title
                    class="headline px-0">
              {{ editMode }} API Key
            </v-card-title>
          </v-toolbar>
          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex xs12 md12 class="py-0">
                <p class="input-label text-style">Organization</p>
                <p class="font-weight-bold">{{organization.name}}</p>
              </v-flex>
              <v-flex xs12 md12 class="py-0 mt-3">
                <p class="input-label text-style">Name</p>
                <v-text-field l
                              class="select-field"
                              clearable
                              v-model="name">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12 class="py-0" v-if="key !== null">
                <p class="input-label text-style">Key</p>
                <p class="font-weight-bold">{{key}}</p>
              </v-flex>
              <v-flex xs12 md12 class="not-bg py-0 dark--text">
                <v-switch
                        v-model="status"
                        :label=" status === true ? 'Enabled' : 'Disabled'"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions class="d-flex flex-column py-0 pb-0">
            <v-spacer></v-spacer>
            <v-btn class="save-btn mb-16px" text @click="saveApi_key()" :disabled="!this.organization || !this.name">
              Save
            </v-btn>
            <v-btn class="cancel-btn" text @click="$router.push('/utilities')">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-layout></v-layout>
    </v-col>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Api_keyEditor',
  props: {
    id: {
      type: String,
      default: null
    },
    api_item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      editMode: 'Create',
      organization_id: null,
      organization: {},
      name: '',
      status: true,
      key: null
    }
  },
  mounted () {
    this.organization = this.currentOrganization
    if (this.id !== 'new') {
      this.editMode = 'Edit'
      this.$store.commit('setActiveApi_key', {})
      if (!this.api_item) {
        this.$store.dispatch('getApi_key', this.id)
      } else {
        this.$nextTick(() => {
          for (const key in this.api_item) {
            if (Object.prototype.hasOwnProperty.call(this.api_item, key)) {
              this[key] = this.api_item[key]
            }
          }
          this.setValues(this, this.api_item)
        })
      }
    } else {
      this.$store.commit('setActiveApi_key', {})
    }
  },
  computed: {
    ...mapGetters(['filtered_api_keys', 'activeApi_key', 'user', '_organizationLoadedItems', 'organizations', 'currentOrganization'])
  },
  methods: {
    saveApi_key () {
      if (this.filtered_api_keys.find(k => k.entity_id !== this.entity_id && k.organization_id === this.organization_id && k.name === this.name)) {
        Vue.notify({
          group: 'messages',
          type: 'error',
          text: 'The name is duplicated.'
        })
        return
      }
      this.setValues(this, this.activeApi_key)
      this.$store.dispatch('saveApi_key', this.api_item ? { ...this.api_item, ...this } : this.activeApi_key)
      this.$router.push('/utilities')
    },
    setValues (source, destination) {
      destination.version = source.version
      if (source.id !== 'new') {
        destination.entity_id = source.entity_id
      }
      destination.organization_id = source.organization_id === undefined ? this.organization.entity_id : source.organization_id
      destination.name = source.name
      destination.status = source.status === undefined ? true : source.status
      if (source.key !== undefined) {
        this.key = source.key // key generated from backend side
      }
    }
  },
  created () {
    if (!this._organizationLoadedItems.organizations) {
      this.$store.dispatch('loadOrganizations')
    }
    if (this.currentOrganization.entity_id) {
      this.organization_id = this.currentOrganization.entity_id
    }
  },
  watch: {
    activeApi_key () {
      this.setValues(this.activeApi_key, this)

      if (!this.id || this.id === 'new') {
        this.organization_id = this.currentOrganization.entity_id
      }
    },
    currentOrganization () {
      this.organization = this.currentOrganization
    }
  }
}
</script>

<style scoped>
  .logo-display {
    border-radius: 10px;
  }

  .input-label {
    font-weight: bold !important;
    color: #212338 !important;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 2.125px;
    text-transform: uppercase;
    opacity: 1 !important;
  }

  .logo-message {
    font-size: 12px;
    color: grey;
    margin-top: 5px;
    margin-bottom: 10px;
    text-align: center;
  }

  .centered {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
  }

  .faded {
    opacity: 0.5;
  }

  .clickable {
    cursor: pointer;
  }

  .not-clickable {
    cursor: not-allowed;
  }
</style>
